import { OFFLINE_CREATE_FILE_DB_INFO } from '@/modules/OfflineFiles/data/OfflineFilesDatabaseInfo';
import useIndexDb from '@/modules/OfflineFiles/hooks/useIndexDb';
import {
  OfflineDbItemReturn,
  OfflineFilesObjectStoreType,
  OfflinePhotosDBTypes,
} from '@/modules/OfflineFiles/types/OfflineFileTypes';
import { useState } from 'react';
import { useParams } from 'react-router-dom';

const useGetOfflineImages = () => {
  const [
    currentIncidentParticipantImages,
    setCurrentIncidentParticipantImages,
  ] = useState<OfflineFilesObjectStoreType>();
  const [offlineError, setOfflineError] = useState<string>('');
  const { id } = useParams();
  const { getAllFromIndexDb, deleteItemFromIndexDb } =
    useIndexDb<OfflinePhotosDBTypes>(OFFLINE_CREATE_FILE_DB_INFO);

  const getCurrentFileOfflineImages = async ({
    damagedId,
  }: {
    damagedId?: string | undefined;
  }): OfflineDbItemReturn => {
    const isDamagedUser = !!damagedId;

    return getAllFromIndexDb()
      .then((item) => {
        let DBItem: OfflineFilesObjectStoreType | undefined = undefined;
        if (isDamagedUser) {
          const damagedImages = item.find(
            (userImages) =>
              userImages.fileId === +id! &&
              userImages.userType === 'damaged' &&
              userImages.damagedId === damagedId,
          );
          // damaged user
          if (damagedImages) {
            DBItem = damagedImages;
          } else {
            setOfflineError('تصاویر افلاین برای این فایل یافت نشد ');
          }
        } else {
          // culprit - initial - body user
          const userImages = item.find(
            (userImages) =>
              userImages.fileId === +id! && userImages.userType !== 'damaged',
          );
          if (userImages) {
            DBItem = userImages;
          } else {
            setOfflineError('تصاویر افلاین برای این فایل یافت نشد ');
          }
        }

        if (DBItem) {
          const images = DBItem?.images?.images;
          images?.damagedImages?.forEach((element) => {
            const url = URL.createObjectURL(element.blob!);
            element.url = url;
          });

          images?.extraImages?.forEach((element) => {
            const url = URL.createObjectURL(element.blob!);
            element.url = url;
          });
          images?.vehicleImages?.forEach((element) => {
            const url = URL.createObjectURL(element.blob!);
            element.url = url;
          });
          const videoUrl = URL.createObjectURL(DBItem?.images?.video?.blob!);
          if (DBItem?.images?.video) DBItem.images.video.url = videoUrl;
          setCurrentIncidentParticipantImages(DBItem);
          return { hasOffline: true, offlineItem: DBItem };
        }

        return { hasOffline: false, offlineItem: null };
      })
      .catch(() => {
        return { hasOffline: false, offlineItem: null };
      });
  };

  const deleteOfflineFileData = (id: number) => {
    return deleteItemFromIndexDb(id);
  };
  return {
    getCurrentFileOfflineImages,
    deleteOfflineFileData,
    DBitem: currentIncidentParticipantImages,
    FileImagesList: currentIncidentParticipantImages?.images?.images,
    video: currentIncidentParticipantImages?.images?.video,
    offlineError,
  };
};

export default useGetOfflineImages;
